<template>
  <div class="NIBUT_Setting">
    <table>
      <tr align="left">
        <td class="nibut_name" style="font-size: 26px; table-layout: fixed">NIBUT:&nbsp;&nbsp;</td>
        <td>
          <el-switch
            v-model="isDrawNIBUT"
            :active-text="showText"
            :inactive-text="notShowText"
            @change="changeSwitch"
          >
          </el-switch>
        </td>
      </tr>
    </table>
    <table>
      <tr align="left">
        <td class="nibut_name" style="font-size: 26px; table-layout: fixed">
          <!-- NIBUT:&nbsp;&nbsp; -->
        </td>
        <td style="padding-left: 97px; height: 40px">
          <el-switch
            v-model="NIBUTModel"
            :active-text="auto"
            :inactive-text="manual"
            @change="changeModel"
          >
          </el-switch>
        </td>
      </tr>
    </table>
    <table v-if="selectState">
      <tr align="left">
        <td class="nibut_name" style="font-size: 26px; table-layout: fixed">
          {{ $t("langcfg.txtLamp") }}:&nbsp;&nbsp;
        </td>
        <td>
          <el-radio-group v-model="SelectLight" @change="changeLight">
            <el-radio :label="true">{{ white }}</el-radio>
            <el-radio style="margin-left: 20px" :label="false">{{ infrared }}</el-radio>
          </el-radio-group>
        </td>
      </tr>
    </table>
  </div>
</template>
<script>
import { nibutInfrared } from "../../../fileoprators/license";
import { saveCaptureSettings } from "../../../settings";
import { isDefined } from "../../../shared/utils";
export default {
  name: "NIBUTSetting",
  data() {
    return {
      isDrawNIBUT: 1,
      showText: this.$t("langcfg.txtOpen"),
      notShowText: this.$t("langcfg.txtShowRuptureArea") + ":  " + this.$t("langcfg.txtClose"),
      auto: this.$t("langcfg.txtAutoSelect"),
      manual: this.$t("langcfg.txtManualSelect"),
      white: this.$t("langcfg.txtWhiteLamp"),
      infrared: this.$t("langcfg.txtInfraredLamp"),
      NIBUTModel: false,
      SelectLight: false,
      selectState: false
    };
  },
  mounted() {
    if (isDefined(window.captureSettings.isDrawNIBUT)) {
      this.isDrawNIBUT = window.captureSettings.isDrawNIBUT === 1;
    } else {
      this.isDrawNIBUT = true;
      window.captureSettings.isDrawNIBUT = 1;
      saveCaptureSettings(window.captureSettings);
    }
    if (isDefined(window.captureSettings.nibutModel)) {
      this.NIBUTModel = window.captureSettings.nibutModel;
    } else {
      this.isDrawNIBUT = false;
      window.captureSettings.nibutModel = false;
      saveCaptureSettings(window.captureSettings);
    }
    if (isDefined(window.captureSettings.SelectLight)) {
      this.SelectLight = window.captureSettings.SelectLight;
    } else {
      window.captureSettings.SelectLight = false;
      saveCaptureSettings(window.captureSettings);
    }
    if (nibutInfrared) {
      this.selectState = true;
    } else {
      this.selectState = false;
    }
  },
  methods: {
    changeSwitch(val) {
      window.captureSettings.isDrawNIBUT = val ? 1 : 0;
      saveCaptureSettings(window.captureSettings);
    },
    changeModel(val) {
      window.captureSettings.nibutModel = val;
      saveCaptureSettings(window.captureSettings);
      this.$store.state.dryeye.windowNibutModel = val;
    },
    changeLight(val) {
      window.captureSettings.SelectLight = val;
      saveCaptureSettings(window.captureSettings);
      this.$bus.$emit("camInit");
      this.$bus.$emit("lampInit", "nibut");
    }
  },
  watch: {}
};
</script>
<style lang="less" scoped>
.NIBUT_Setting {
  .demo-form-inline {
    margin-top: 30px;
  }

  margin-top: 30px;
  margin-left: 40px;
  /deep/ .el-form-item__label {
    font-size: 28px !important;
  }
}
.nibut_name {
  padding-top: 10px;
}
/deep/.el-switch__label * {
  font-size: 27px;
}
/deep/.el-radio {
  display: inline-flex;
}
</style>



// WEBPACK FOOTER //
// src/mainInterface/components/settings/NIBUTSetting.vue